import * as React from 'react';
import { ReactRouterHooks } from 'tree-wallet-client';
import Result from 'antd/es/result';
import Button from 'antd/es/button';
import { withReactRouter } from '../../Helper/HooksHelper';
import { logout } from '../../Service/AuthService';

interface ErrorPageProps extends ReactRouterHooks {
  template: '404'|'403'|'generic';
  subTitle?: string;
  contents?: string|React.ReactNode;
  /** The one way out of the screen: a logout button unless the page names another one */
  buttonLabel?: string;
  onButtonClick?: () => void;
}

class ErrorPage extends React.Component<ErrorPageProps, any> {
  private templates = {
    '403': <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={this.getActionButton()}
    />,
    '404': <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={this.getActionButton()}
    />,
    'generic': <Result
      status="error"
      title="Error"
      subTitle={this.props.subTitle}
      extra={this.getActionButton()}
    >
      {this.props.contents}
    </Result>
  }

  constructor(props: ErrorPageProps) {
    super(props);
  }

  getActionButton() {
    const { buttonLabel, onButtonClick } = this.props;

    return <Button type="primary" onClick={onButtonClick || logout}> {buttonLabel || 'Logout'} </Button>;
  }

  render() {
    const { template } = this.props;
    return this.templates[template];
  }
}

export default withReactRouter(ErrorPage);
